import { getMv } from '@/request/api/item.js';
import { mapMutations } from 'vuex';
export default {
  props: ['songList', 'searchSongList'],

  updated() {
    console.log(this.songList);
    console.log(this.searchSongList);
  },

  methods: {
    playmusic(index) {
      this.updatePlayList(this.songList);
      this.updateplayListIndex(index);
    },

    getmv: async function (index) {
      let res = null;

      if (this.songList) {
        res = await getMv(this.songList[index].mv);
        console.log(res);
      } else {
        res = await getMv(this.searchSongList[index].mvid);
        console.log(res);
      } // console.log(index);


      if (res.data.data.id !== '') {
        this.$router.push({
          path: '/mv',
          query: {
            id: res.data.data.id,
            // musicid: this.songList[index].id
            arurl: res.data.data.artists[0].img1v1Url,
            name: res.data.data.name,
            arname: res.data.data.artists[0].name,
            cover: res.data.data.cover
          }
        });
      }
    },

    updateIndex(item) {
      item.al = item.album;
      item.al.picUrl = item.album.artist.img1v1Url;
      item.ar = item.artists;
      this.$store.commit('pushPlayList', item);
      this.$store.commit('updateplayListIndex', this.$store.state.playList.length - 1);
    },

    ...mapMutations(['updatePlayList', 'updateplayListIndex'])
  }
};